"use client";

import React from "react";

interface WaveHeaderProps {
  title?: string;
  subtitle?: string;
  controls?: React.ReactNode;
}

const WaveHeader: React.FC<WaveHeaderProps> = ({
  title,
  subtitle,
  controls,
}) => {
  const hasContent = title || subtitle || controls;

  return (
    <div className="relative w-full overflow-hidden">
      {/* HEADER */}
      <header className={`relative bg-main text-white px-4 md:px-12 transition-all ${hasContent ? "pt-12 pb-20" : "pt-4 pb-12"
        }`}>
        {/* Subtle glow */}
        <div className="absolute inset-0 bg-main pointer-events-none" />

        {hasContent && (
          <div className="relative z-10 max-w-7xl mx-auto text-center space-y-3">
            {title && (
              <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight animate-in fade-in duration-600">
                {title}
              </h1>
            )}

            {subtitle && (
              <p className="text-pink-100 text-base md:text-lg max-w-2xl mx-auto animate-in fade-in duration-800">
                {subtitle}
              </p>
            )}

            {controls && (
              <div className="mt-6 flex justify-center">
                <div className="w-full max-w-3xl px-2">{controls}</div>
              </div>
            )}
          </div>
        )}

        {/* SVG Shape Divider (simple, modern) */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none pointer-events-none" aria-hidden>
          <svg className="block w-full h-20 md:h-28" viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,32 C360,96 1080,0 1440,64 L1440,120 L0,120 Z" fill="#f8fafc" />
          </svg>
        </div>
      </header>
    </div>
  );
};

export default WaveHeader;
